import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import { DashboardGridLayoutItem } from '../../views/dashboard-view.component';
import { GetTileSets, GetTileSetsVariables } from '../queries/generated/GetTileSets';
import { getTileSets } from '../queries/get-tile-sets.graphql';

export interface KatoidPoint {
   x: number;
   y: number;
}

@Injectable({ providedIn: 'root' })
export class AddTileApiService {
   constructor(private apiService: LcsApiService) {}

   loadTileSets(): Observable<ExecutionResult<GetTileSets>> {
      return this.apiService.query<GetTileSets, GetTileSetsVariables>({
         query: getTileSets,
         variables: { filters: '' },
      });
   }

   getOpenSpace(
      displayLayout: DashboardGridLayoutItem[],
      targetWidth: number = 1,
      targetHeight: number = 1,
      columnLayoutSize: number = 6
   ): KatoidPoint {
      const sumHeight = displayLayout.reduce((acc, curr) => acc + curr.h, 0);
      const filledSpacesMap = new Map<string, true>();
      displayLayout.forEach((dt) => {
         const { x, y, w: width, h: height } = dt;

         let startingY = y;
         while (filledSpacesMap.get(`${x}-${startingY}`)) {
            startingY++;
         }

         for (let i = startingY; i < startingY + height; i++) {
            for (let j = x; j < x + width; j++) {
               filledSpacesMap.set(`${j}-${i}`, true);
            }
         }
      });

      for (let i = 0; i < sumHeight; i++) {
         let openSpaceXKeys: number[] = [];
         for (let j = 0; j < columnLayoutSize; j++) {
            const isFilled = filledSpacesMap.get(`${j}-${i}`);
            if (isFilled) {
               openSpaceXKeys = [];
            } else {
               openSpaceXKeys.push(j);
            }
            if (openSpaceXKeys.length === targetWidth) {
               let currY = i;
               let consecutiveYCount = 1;
               while (openSpaceXKeys.reduce((acc, xKey) => acc && !filledSpacesMap.get(`${xKey}-${currY}`), true)) {
                  if (consecutiveYCount === targetHeight) {
                     return {
                        x: j - targetWidth + 1,
                        y: i,
                     };
                  }
                  consecutiveYCount++;
                  currY++;
               }
            }
         }
      }

      return {
         x: 0,
         y: sumHeight,
      };
   }
}
